import { SubscriberEssential } from "./subscriber";


export class SistemaTSNotification {

    constructor(data) {
        this.id = data.id;
        this.subscriber = new SubscriberEssential(data.subscriber_data);
        this.date = data.date;
        this.n_registry = data.n_registry;
        this.type = data.type;
        this.state = data.state;
        this.error_message = data.error_message;
    }
}